// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1H0di","header":"ClearentDisclaimer_header__lR1f-","inner":"ClearentDisclaimer_inner__3pSHw"};